import { convertSecondsFromMidnightIntoDateTime } from '@utils/time'

interface Errors {
  start: string[]
  end: string[]
}

interface ValidationResult {
  errors: Errors
  isInvalid: boolean
}

export const validate = ({
  startTime,
  endTime,
  minTime,
  maxTime,
  timeZone,
  relativeDate,
}: {
  startTime: number | null
  endTime: number | null
  relativeDate: DateTime // DateTime that that start/end seconds are relative to
  timeZone: string
  minTime: DateTime
  maxTime: DateTime
}): ValidationResult => {
  const errors: Errors = {
    start: [],
    end: [],
  }

  const minTimeInTimeZone = minTime.setZone(timeZone)
  const maxTimeInTimeZone = maxTime.setZone(timeZone)

  if (startTime !== null && endTime !== null) {
    if (endTime <= startTime) {
      errors.end.push('End must be later than start')
    }
  }

  if (startTime !== null) {
    const startDateTime = convertSecondsFromMidnightIntoDateTime(
      startTime,
      relativeDate,
      timeZone,
    )

    if (startDateTime < minTimeInTimeZone) {
      errors.start.push(
        `You may only enter time beginning at ${minTimeInTimeZone.toFormat(
          't',
        )} on this Time Card. Please enter time before ${minTimeInTimeZone.toFormat(
          't',
        )} on the prior day's Time Card`,
      )
    } else if (startDateTime >= maxTimeInTimeZone) {
      errors.start.push(
        `You may only enter time up to ${maxTimeInTimeZone.toFormat(
          't',
        )} on this Time Card. Please enter time after ${maxTimeInTimeZone.toFormat(
          't',
        )} on the next day's Time Card`,
      )
    }
  }

  if (endTime !== null) {
    const endDateTime = convertSecondsFromMidnightIntoDateTime(
      endTime,
      relativeDate,
      timeZone,
    )

    if (endDateTime <= minTimeInTimeZone) {
      errors.end.push(
        `You may only enter time beginning at ${minTimeInTimeZone.toFormat(
          't',
        )} on this Time Card. Please enter time before ${minTimeInTimeZone.toFormat(
          't',
        )} on the prior day's Time Card`,
      )
    } else if (endDateTime > maxTimeInTimeZone) {
      errors.end.push(
        `You may only enter time up to ${maxTimeInTimeZone.toFormat(
          't',
        )} on this Time Card. Please enter time after ${maxTimeInTimeZone.toFormat(
          't',
        )} on the next day's Time Card`,
      )
    }
  }

  return {
    errors,
    isInvalid: Object.values(errors).some((e: string[]) => e.length > 0),
  }
}
